// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"2cde117e","298":"71f80b8a","583":"353583e2","787":"dcde9b11"}[chunkId] + ".chunk.js";
};